import { render } from "./WorkbenchComponent.vue?vue&type=template&id=5f499cf0&scoped=true"
import script from "./WorkbenchComponent.vue?vue&type=script&lang=js"
export * from "./WorkbenchComponent.vue?vue&type=script&lang=js"

import "./WorkbenchComponent.vue?vue&type=style&index=0&id=5f499cf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f499cf0"]])

export default __exports__